export default __webpack_public_path__ + "static/media/awesomity.129ecc3e.png";